import { SeverityColors, SEVERITY_LABEL } from '@/lib/theme';

export default function SeverityBadge({ severity, size = 'sm', testId }) {
  const c = SeverityColors[severity] || SeverityColors.uncertain;
  const label = SEVERITY_LABEL[severity] || severity;
  const px = size === 'md' ? 'px-3 py-1 text-xs' : 'px-2 py-0.5 text-[11px]';
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center font-extrabold uppercase tracking-wide rounded-full border ${px}`}
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
    >
      {label}
    </span>
  );
}
